import {Platform} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  z-index: 2;
  background-color: ${({theme}) => theme.colors.blue};
  position: absolute;
  top: 0;
  padding: 0 24px;
  padding-top: ${Platform.OS === 'android' ? RFValue(6) : RFValue(0)}px;
  padding-bottom: ${Platform.OS === 'android' ? RFValue(6) : RFValue(0)}px;
  width: 100%;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  width: 80%;
`;

export const CloseButton = styled.TouchableOpacity``;

export const CloseIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.shape};
`;
